"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var AppMargins_1 = require("../../AppMargins");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        bannerContainer: {
            display: 'flex',
            position: function (props) { return (props.isSticky ? 'fixed' : 'relative'); },
            zIndex: function (props) { return (props.isSticky ? 20 : 1); },
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            minHeight: 50,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.default,
            paddingTop: 15,
            paddingBottom: 15,
        },
        appMargins: {
            width: '100%',
        },
        bannerContent: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'flex-start',
            width: '100%',
        },
        typography: (_a = {
                fontSize: 13,
                fontWeight: 400
            },
            _a[theme.breakpoints.up('xs')] = {
                fontSize: 14,
            },
            _a),
    });
});
function Banner(_a) {
    var text = _a.text, icon = _a.icon, isSticky = _a.isSticky;
    var classes = useStyles({ text: text, isSticky: isSticky });
    return (react_1.default.createElement("div", { className: classes.bannerContainer },
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, { className: classes.appMargins },
            react_1.default.createElement("div", { className: classes.bannerContent },
                icon,
                react_1.default.createElement(core_1.Typography, { className: classes.typography }, text)))));
}
exports.default = Banner;
